import type { ApiClient, Appointment } from "@shyne/shared/api";
import type { uuid } from "@/interfaces";
type CompletionApi = Pick<ApiClient["appointments"], "complete">;

export type CompletionAsked = { reason?: string; actingOrganization: uuid | null };

export function createCompletion(api: CompletionApi) {
  return function complete(id: uuid, { reason, actingOrganization }: CompletionAsked): Promise<Appointment> {
    const given = reason?.trim();
    return api.complete(id, { ...(given ? { reason: given } : {}), ...(actingOrganization ? { actingOrganization } : {}) });
  };
}
